module.exports = __webpack_public_path__ + "img/horizontal_4_3_r_8017.11ed304e.png";